/**
 * 充值记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const rechargeCommonConfig = {
  texts: {
    noRecord: 'No record',
    discountedVip: 'Discounted Vip',
    unlimitedVip: 'Unlimited Vip',
    coins: 'Coins',
    expireOn: 'Expire on',
    noMore: 'No more ~',
    loading: 'Loading...',
  },
}
